import authApi from "@/services/auth-api"
import type {
  SetTenantResponse,
  TenantId,
  UserCompanies
} from "@/types/tenants"

export class TenantsApi {
  public setTenant = (companyId: TenantId) =>
    authApi.get<SetTenantResponse>(`/api/v1/company/${companyId}`)

  public getUserTenants = (username: string) =>
    authApi.get<UserCompanies>(`/api/v1/user/${username}`)
}
